// src/auth/MsalProvider.tsx
import React, { useEffect, useState } from 'react';
import {
  PublicClientApplication,
  EventType,
  EventMessage,
  AuthenticationResult,
} from '@azure/msal-browser';
import { msalConfig } from './authConfig';

export const msalInstance = new PublicClientApplication(msalConfig);

interface MsalProviderProps {
  // eslint-disable-next-line no-unused-vars
  onMsalReady?: (instance: PublicClientApplication) => void; // Make this optional
  children: React.ReactNode;
}

const MsalProvider: React.FC<MsalProviderProps> = ({ onMsalReady, children }) => {
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    msalInstance.initialize().then(() => {
      const accounts = msalInstance.getAllAccounts();
      if (accounts.length > 0) {
        msalInstance.setActiveAccount(accounts[0]);
      }

      msalInstance.addEventCallback((event: EventMessage) => {
        if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
          const payload = event.payload as AuthenticationResult;
          msalInstance.setActiveAccount(payload.account);
        }
      });

      setIsInitialized(true);

      if (onMsalReady) {
        onMsalReady(msalInstance); // Call onMsalReady only if provided
      }
    });
  }, [onMsalReady]);

  if (!isInitialized) {
    return <div>Loading...</div>;
  }

  return <>{children}</>;
};

export default MsalProvider;
